import * as React from 'react';

import AccessibleSVG from '../accessible-svg';

import { Icon } from '../iconTypes';

const IconAccessStats = ({ className = '', color = '#444', height = 10, title, width = 14 }: Icon) => (
    <AccessibleSVG
        className={`icon-access-stats ${className}`}
        height={height}
        title={title}
        viewBox="0 0 14 10"
        width={width}
    >
        <path
            d="M1 6v3h1.99c.012 0 .01.002.01 0V6H1.01C.997 6 1 5.998 1 6zM0 6a1 1 0 0 1 1.01-1h1.98C3.55 5 4 5.444 4 6v3a1 1 0 0 1-1.01 1H1.01C.45 10 0 9.556 0 9V6zm6-1.997v4.994c0 .006-.003.003.01.003h1.98c.012 0 .01.002.01-.003V4.003C8 3.997 8.003 4 7.99 4H6.01C5.997 4 6 3.998 6 4.003zm-1 0C5 3.45 5.443 3 6.01 3h1.98C8.55 3 9 3.438 9 4.003v4.994C9 9.55 8.557 10 7.99 10H6.01A.998.998 0 0 1 5 8.997V4.003zm6-3.008v8.01c0-.01.006-.005.01-.005h1.98c.013 0 .01.003.01.005V.995c0 .01-.006.005-.01.005h-1.98C10.996 1 11 .997 11 .995zm-1 0c0-.55.443-.995 1.01-.995h1.98c.56 0 1.01.456 1.01.995v8.01c0 .55-.443.995-1.01.995h-1.98c-.56 0-1.01-.456-1.01-.995V.995z"
            fill={color}
            fillRule="evenodd"
        />
    </AccessibleSVG>
);

export default IconAccessStats;
